// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file customer/management/v1/service.proto (package customer.management.v1, syntax proto3)
/* eslint-disable */

import { CustomerManagementService } from "./service_pb";

/**
 * @generated from rpc customer.management.v1.CustomerManagementService.ListUsers
 */
export const listUsers = CustomerManagementService.method.listUsers;

/**
 * @generated from rpc customer.management.v1.CustomerManagementService.RemoveUserFromTenant
 */
export const removeUserFromTenant = CustomerManagementService.method.removeUserFromTenant;

/**
 * @generated from rpc customer.management.v1.CustomerManagementService.GetUserById
 */
export const getUserById = CustomerManagementService.method.getUserById;

/**
 * @generated from rpc customer.management.v1.CustomerManagementService.UpdateUserRole
 */
export const updateUserRole = CustomerManagementService.method.updateUserRole;

/**
 * @generated from rpc customer.management.v1.CustomerManagementService.GetIntakeAllowedDomains
 */
export const getIntakeAllowedDomains = CustomerManagementService.method.getIntakeAllowedDomains;

/**
 * @generated from rpc customer.management.v1.CustomerManagementService.UpdateIntakeAllowedDomains
 */
export const updateIntakeAllowedDomains = CustomerManagementService.method.updateIntakeAllowedDomains;

/**
 * Issue a GitBook-compatible JWT so authenticated Lema users can view docs.lema.ai
 *
 * @generated from rpc customer.management.v1.CustomerManagementService.GenerateGitbookSSO
 */
export const generateGitbookSSO = CustomerManagementService.method.generateGitbookSSO;
